import { Api } from "./api"

const PATH = 'facture'
const ENDPOINTS = {
    Liste:'liste',
    Search:'search',
    Show:'show'
}

const getFactures = (params={},signal) => {
    const query = new URLSearchParams(params).toString()
    return Api.get(`${PATH}/${ENDPOINTS.Liste}${query ? `?${query}` : ''}`, signal)
}

const searchFactures = (params={},signal) => {
    const query = new URLSearchParams(params).toString()
    return Api.get(`${PATH}/${ENDPOINTS.Search}${query ? `?${query}` : ''}`, signal)
}

const getFactureDetails = (id,signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Show}/${id}`, signal)
}

export const FactureApi={
    getFactures,
    searchFactures,
    getFactureDetails
}
